// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Logo-module--cls1--RjuQ2","cls2":"styles-Logo-module--cls2--2jz0L styles-Logo-module--cls1--RjuQ2"};